import { USERTYPES } from 'components/Common/Constant';
import { useEffect, useRef } from 'react';
import './AddModal.css';

const AddModal = ({ modal, setModal, handleSubmit, setAddUserData, addUserData, isModifying }) => {
  const firstInputRef = useRef(null);

  useEffect(() => {
    if (modal) {
      // Scroll to top when modal opens
      window.scrollTo({ top: 0, behavior: 'smooth' });
      // Focus first input
      setTimeout(() => {
        firstInputRef.current?.focus();
      }, 100);
    }
  }, [modal]);

  const toggle = () => setModal(!modal)

  const handleInputChange = async (e) => {
    try {
      setAddUserData((pre) => ({
        ...pre,
        [e.target.name]: e.target.value
      }))
    } catch (e) {
      console.error(e);
    }
  }

  if (!modal) return null;

  return (
    <div
      onClick={(e) => e.target === e.currentTarget && toggle()}
      style={{
        position: 'fixed',
        top: '0',
        left: '0',
        right: '0',
        bottom: '0',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        zIndex: 99999,
        overflowY: 'auto',
        paddingTop: '3rem',
        paddingLeft: '1rem',
        paddingRight: '1rem'
      }}
    >
      <div className="add-modal-container">
        <div className="add-modal-content">
          {/* Header */}
          <div className="add-modal-header">
            <h5 className="add-modal-title">Add User</h5>
            <button type="button" className="add-modal-close" onClick={toggle}>×</button>
          </div>

          {/* Body */}
          <form onSubmit={handleSubmit}>
            <div className="add-modal-body">
              <div className="add-form-row">
                <div className="add-form-col">
                  <label className="add-form-label">First Name</label>
                  <input
                    ref={firstInputRef}
                    type="text"
                    name="firstname"
                    className="add-form-input"
                    placeholder="Enter first name"
                    value={addUserData?.firstname || ''}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="add-form-col">
                  <label className="add-form-label">Last Name</label>
                  <input
                    type="text"
                    name="lastname"
                    className="add-form-input"
                    placeholder="Enter last name"
                    value={addUserData?.lastname || ''}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>

              <div className="add-form-group">
                <label className="add-form-label">Email Address</label>
                <input
                  type="email"
                  name="email"
                  className="add-form-input"
                  placeholder="Enter email address"
                  value={addUserData?.email || ''}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="add-form-group">
                <label className="add-form-label">Password</label>
                <input
                  type="password"
                  name="password"
                  className="add-form-input"
                  placeholder="Enter password"
                  value={addUserData?.password || ''}
                  onChange={handleInputChange}
                  required
                />
                <small className="add-form-hint">Minimum 8 characters</small>
              </div>

              <div className="add-form-group">
                <label className="add-form-label">User Type</label>
                <select
                  name="userType"
                  className="add-form-dropdown"
                  onChange={handleInputChange}
                  required
                >
                  <option value="globaladmin">Global Admin</option>
                  <option value="organizationadmin">Organization Admin</option>
                  <option value="standard">Standard</option>
                </select>
                <small className="add-form-hint">Minimum 8 characters</small>
              </div>
            </div>

            {/* Footer */}
            <div className="add-modal-footer">
              <button
                type="button"
                className="add-btn add-btn-cancel"
                onClick={toggle}
                disabled={isModifying}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="add-btn add-btn-submit"
                style={{ backgroundColor: '#10b981', color: 'white' }}
                disabled={isModifying}
              >
                {isModifying ? 'Adding...' : 'Add User'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default AddModal
